module.exports = __webpack_public_path__ + "img/LATIN10_00.b0b3e107.jpg";